export const isTheDomainAWhitelabel = (domain: string) => {
  for (const whitelabelDomain of whitelabelsDomains) {
    if (domain.includes(whitelabelDomain)) {
      return true
    }
  }
  return false
}

export const isTheDomainProtegezVousWhitelabel = (domain: string) => domain.includes(protegezVousWhitelabelDomain)

export const isTheDomainAPlanHubDevServer = (domain: string) => /^dev[0-9]+\.planhub\.ca$/i.test(domain)

const shouldUseCurrentOrigin = (domain: string) =>
  isTheDomainAWhitelabel(domain) || isTheDomainAPlanHubDevServer(domain)

export const getBaseUrl = (): string => {
  if (shouldUseCurrentOrigin(window.location.hostname)) {
    return window.location.origin
  }
  return process.env.REACT_APP_SCENARIO_OUTPUT_URL!
}

const protegezVousWhitelabelDomain = 'protegezvous.planhub.ca'

const whitelabelsDomains: string[] = [
  'mobilesyrup.planhub.ca',
  'ratehub.planhub.ca',
  'francoischarron.planhub.ca',
  protegezVousWhitelabelDomain,
  'lactualite.planhub.ca',
  'redflagdeals.planhub.ca',
]
